import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import styled from 'styled-components'
import { FaSpinner, FaBrain } from 'react-icons/fa'
import { Model } from '../../types/models/model'
import ModelTrainingCard from '../views/InferenceLoop/components/ModelTrainingCard'
import { Project } from '../../types/models/project'

const StyledModal = styled(Modal)`
  .modal-content {
    background: #1a1a1a;
    border: 1px solid #3a3a3a;
    border-radius: 12px;
  }

  .modal-header {
    border-bottom: 1px solid #3a3a3a;
    padding: 1rem 1.5rem;
  }

  .modal-body {
    padding: 1.5rem;
  }

  .modal-title {
    color: #fff;
    font-size: 1.25rem;
    font-weight: 600;
  }

  .btn-close {
    filter: invert(1) grayscale(100%) brightness(200%);
  }
`

interface ModelTrainingModalProps {
  show: boolean
  onHide: () => void
  model: Model
  project: Project | undefined
  isRetraining: boolean
  selectedTrainingSources: string[]
  selectedValidationSources: string[]
  selectedTagIds: string[]
  totalTrainingImages: number
  totalTrainingAnnotations: number
  totalValidationImages: number
  totalValidationAnnotations: number
  onTrainingSourcesChange: (sources: string[]) => void
  onValidationSourcesChange: (sources: string[]) => void
  onTagSelectionChange: (tagIds: string[]) => void
  onRetrain: () => void
}

const ModelTrainingModal: React.FC<ModelTrainingModalProps> = ({
  show,
  onHide,
  model,
  project,
  isRetraining,
  selectedTrainingSources,
  selectedValidationSources,
  selectedTagIds,
  totalTrainingImages,
  totalTrainingAnnotations,
  totalValidationImages,
  totalValidationAnnotations,
  onTrainingSourcesChange,
  onValidationSourcesChange,
  onTagSelectionChange,
  onRetrain,
}) => {
  return (
    <StyledModal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>Fine-Tune Model</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Training configuration without fine-tune button */}
        <ModelTrainingCard
          model={model}
          project={project}
          isRetraining={isRetraining}
          selectedTrainingSources={selectedTrainingSources}
          selectedValidationSources={selectedValidationSources}
          selectedTagIds={selectedTagIds}
          totalTrainingImages={totalTrainingImages}
          totalTrainingAnnotations={totalTrainingAnnotations}
          totalValidationImages={totalValidationImages}
          totalValidationAnnotations={totalValidationAnnotations}
          onTrainingSourcesChange={onTrainingSourcesChange}
          onValidationSourcesChange={onValidationSourcesChange}
          onTagSelectionChange={onTagSelectionChange}
        />
      </Modal.Body>
      <Modal.Footer style={{ background: '#1a1a1a', borderTop: '1px solid #3a3a3a' }}>
        <Button variant="outline-secondary" onClick={onHide} disabled={isRetraining}>
          Cancel
        </Button>
        <Button
          style={{
            background: 'linear-gradient(135deg, #9333ea 0%, #c084fc 100%)',
            border: 'none',
            color: '#ffffff',
          }}
          onClick={() => {
            onRetrain()
            onHide()
          }}
          disabled={isRetraining}
        >
          {isRetraining ? (
            <>
              <FaSpinner className="me-2" style={{ animation: 'spin 1s linear infinite' }} />
              Training...
            </>
          ) : (
            <>
              <FaBrain className="me-2" />
              Start Fine-Tuning
            </>
          )}
        </Button>
      </Modal.Footer>
    </StyledModal>
  )
}

export default ModelTrainingModal
